module.exports = __webpack_public_path__ + "static/media/rewards_premium_exp.89780c59.png";